<template>
  <div class="home-product">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <!-- 动态楼层渲染 -->
      <div class="floor-container">
        <div v-for="floor in blockList" :key="floor.blockId" class="floor-item">
          <!-- typeId=1: 轮播图 -->
          <div v-if="floor.typeId === 1 && floor.retailHomepageDetails && floor.retailHomepageDetails.length > 0" class="floor-banner">
            <van-swipe class="banner-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for="(banner, idx) in floor.retailHomepageDetails" :key="idx" @click="onBannerClick(banner)">
                <img :src="banner.wechatImg || banner.appImg || banner.imageUrl" class="banner-img" />
              </van-swipe-item>
            </van-swipe>
          </div>

          <!-- typeId=5: 金刚区（分类导航） -->
          <div v-else-if="floor.typeId === 5 && floor.retailHomepageDetails && floor.retailHomepageDetails.length > 0" class="floor-category">
            <div class="top-menus">
              <div
                v-for="(menu, idx) in floor.retailHomepageDetails"
                :key="idx"
                class="menu-item"
                @click="onCategoryClick(menu)"
              >
                <img :src="menu.appImg || menu.wechatImg || menu.imageUrl || menu.productUrl" class="menu-icon" />
                <span class="menu-title">{{ menu.tabName }}</span>
              </div>
            </div>
          </div>

          <!-- typeId=3: 广告位 -->
          <div v-else-if="floor.typeId === 3 && floor.retailHomepageDetails && floor.retailHomepageDetails.length > 0" class="floor-ad">
            <div class="ad-wrapper" @click="onAdClick(floor.retailHomepageDetails[0])">
              <img :src="floor.retailHomepageDetails[0].appImg || floor.retailHomepageDetails[0].wechatImg || floor.retailHomepageDetails[0].imageUrl" class="ad-image" />
            </div>
          </div>

          <!-- typeId=6: 活动板块 -->
          <div v-else-if="floor.typeId === 6" class="floor-activity">
            <home-activity :floor="floor" @click="onActivityClick" />
          </div>

          <!-- typeId=9: 新版商品+广告混合楼层 -->
          <div v-else-if="floor.typeId === 9" class="floor-goods-new">
            <home-goods-new
              v-for="detail in floor.retailHomepageDetails"
              :key="detail.id"
              :item="detail"
              :is-store="isStore"
              @clickMore="onAdClick"
              @clickImage="onAdClick"
            />
          </div>

          <!-- typeId=2: 商品列表(旧版) -->
          <div v-else-if="floor.typeId === 2" class="floor-goods-old">
            <div class="goods-grid-old">
              <div
                v-for="goods in floor.retailHomepageDetails"
                :key="goods.id"
                class="goods-card-old"
                @click="onGoodsClick(goods)"
              >
                <img :src="goods.thumbnailUrl" class="goods-image-old" />
                <div class="goods-info-old">
                  <div class="goods-name-old">{{ goods.name }}</div>
                  <div class="goods-price-old">¥{{ goods.price }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 我的订阅 -->
        <div v-if="mySubmodelList.length > 0" class="subscribe-section">
          <div class="subscribe-title">我的订阅</div>
          <div class="subscribe-scroll-wrapper">
            <div class="subscribe-list">
              <div
                v-for="sub in mySubmodelList"
                :key="sub.id"
                class="subscribe-item"
                @click="onSubscribeClick(sub)"
              >
                <img :src="sub.imageUrl" class="sub-image" />
                <span class="sub-name">{{ sub.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </van-pull-refresh>

    <!-- 底部商品分类流 -->
    <home-bottom-view
      ref="homeBottomView"
      :bottom-list-model="bottomListModel"
      :is-store="isStore"
      @showPoster="onShowPoster"
    />
  </div>
</template>

<script>
import HomeActivity from "./HomeActivity.vue";
import HomeGoodsNew from "./HomeGoodsNew.vue";
import HomeBottomView from "./HomeBottomView.vue";
import { isLogin, getCurrentRole } from "@/utils/authority";
import {
  findStoreByCondition,
  retailHomepage,
  getUserActivitySubCards,
  getSearchKeywordList,
  findTPushCount
} from "@/api/home";
import { getCartList } from "@/api/cart";

export default {
  name: "HomeProduct",
  components: {
    HomeActivity,
    HomeGoodsNew,
    HomeBottomView
  },
  data() {
    return {
      refreshing: false,
      blockList: [],
      bottomListModel: null,
      mySubmodelList: [],
      hotSearchList: [],
      cartCount: 0,
      msgtotalCount: 0,
      shopInfo: {},
      isStore: false
    };
  },
  computed: {
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  watch: {
    getUserInfo: {
      deep: true,
      handler(newVal) {
        if (newVal && newVal.roles) {
          const oldIsStore = this.isStore;
          this.checkUserRole();
          if (oldIsStore !== this.isStore) {
            if (this.$route.path === "/home" || this.$route.path === "/") {
              this.init();
            }
          }
        }
      }
    }
  },
  created() {
    this.checkUserRole();
    this.init();
  },
  methods: {
    checkUserRole() {
      const role = getCurrentRole();
      this.isStore = role === "Store";
    },
    async init() {
      try {
        await Promise.all([
          this.loadStoreInfo(),
          this.loadHomeFloors(),
          this.loadMySubscribe(),
          this.loadHotSearch()
        ]);
        
        // 延迟加载购物车和消息
        setTimeout(() => {
          this.loadCartCount();
          this.loadMessageCount();
        }, 1000);
      } catch (error) {
        console.error("首页初始化失败", error);
      } finally {
        this.refreshing = false;
      }
    },
    async onRefresh() {
      this.refreshing = true;
      this.checkUserRole();
      if (this.$refs.homeBottomView) {
        this.$refs.homeBottomView.reloadData();
      }
      await this.init();
    },
    async loadStoreInfo() {
      try {
        const res = await findStoreByCondition({ origin: "Front", slug: this.slug });
        if (res && res.code === 1) {
          this.shopInfo = res.data || {};
        }
      } catch (err) {
        console.error("加载店铺信息失败", err);
      }
    },
    async loadHomeFloors() {
      try {
        const res = await retailHomepage({ newVersion: "B", slug: this.slug });
        if (res && res.code === 1 && Array.isArray(res.data)) {
          const dataList = res.data;
          const blocks = [];
          let bottomModel = null;
          dataList.forEach(item => {
            if (item.typeId === 4) {
              bottomModel = item;
            } else {
              blocks.push(item);
            }
          });
          this.blockList = blocks;
          this.bottomListModel = bottomModel;
        } else {
          this.blockList = [];
          this.bottomListModel = null;
        }
      } catch (err) {
        console.error("加载楼层失败", err);
      }
    },
    async loadMySubscribe() {
      try {
        const res = await getUserActivitySubCards({ slug: this.slug });
        if (res && res.code === 1) {
          this.mySubmodelList = res.data || [];
        }
      } catch (err) {
        console.error("加载订阅列表失败", err);
      }
    },
    async loadHotSearch() {
      try {
        const res = await getSearchKeywordList({ slug: this.slug });
        let list = [];
        if (res && res.code === 1) {
          const data = res.data;
          if (Array.isArray(data)) {
            list = data;
          } else if (data && Array.isArray(data.rows)) {
            list = data.rows;
          }
        }
        this.hotSearchList = list;
        this.$emit("updateHotSearch", this.hotSearchList);
      } catch (err) {
        console.error("加载热搜词失败", err);
      }
    },
    async loadCartCount() {
      if (!isLogin()) return;
      try {
        const res = await getCartList({ slug: this.slug });
        if (res && res.code === 1 && res.data) {
          this.cartCount = res.data.totalNum || 0;
          this.emitCounts();
        }
      } catch (err) {
        console.error("加载购物车数失败", err);
      }
    },
    async loadMessageCount() {
      if (!isLogin()) return;
      try {
        const res = await findTPushCount({ registerLine: 1, slug: this.slug });
        if (res && res.code === 1 && Array.isArray(res.data)) {
          let totalCount = 0;
          res.data.forEach(item => {
            totalCount += (item.count || 0);
          });
          this.msgtotalCount = totalCount;
          this.emitCounts();
        }
      } catch (err) {
        console.error("加载消息数失败", err);
      }
    },
    emitCounts() {
      this.$emit("updateCount", {
        cartCount: this.cartCount,
        msgtotalCount: this.msgtotalCount
      });
    },
    onBannerClick(banner) {
      this.adJumpTo(banner);
    },
    onCategoryClick(menu) {
      this.adJumpTo(menu);
    },
    onAdClick(ad) {
      this.adJumpTo(ad);
    },
    onActivityClick(item) {
      this.adJumpTo(item);
    },
    onSubscribeClick(sub) {
      this.adJumpTo(sub);
    },
    onGoodsClick(goods) {
      this.$router.push({
        path: "/product/detail",
        query: { id: goods.id }
      });
    },
    onShowPoster(item) {
      this.$emit("showPoster", item);
    },
    adJumpTo(item) {
      if (!item) return;
      const forwardDetail = item.forwardDetail;
      switch (item.forwardType) {
        case 1:
          if (forwardDetail) {
            if (forwardDetail.startsWith("http")) {
              window.location.href = forwardDetail;
            } else {
              this.$router.push(forwardDetail);
            }
          }
          break;
        case 2:
          this.$router.push({ path: "/category", query: { id: forwardDetail } });
          break;
        case 3:
          this.$router.push({ path: "/product/detail", query: { id: forwardDetail } });
          break;
        case 5:
        case 8:
          this.$router.push({ path: "/home/themelist", query: { id: forwardDetail } });
          break;
        case 10:
          this.$router.push("/category/brand");
          break;
        case 11:
          this.$toast("素材详情开发中...");
          break;
        default:
          console.log("H5 adJumpTo未处理的类型：", item);
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home-product {
  width: 100%;
  background-color: #f7f8fa;
}
.floor-container {
  width: 100%;
}
.floor-item {
  width: 100%;
  margin-bottom: 12px;
}
.floor-banner {
  padding: 0 12px;
  box-sizing: border-box;
}
.banner-swipe {
  border-radius: 8px;
  overflow: hidden;
  height: 150px;
  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.floor-category {
  // padding: 0 12px;
  box-sizing: border-box;
}
.top-menus {
  display: flex;
  // background-color: #fff;
  // padding: 12px 0;
  border-radius: 8px;
}
.menu-item {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.menu-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 4px;
}
.menu-title {
  font-size: 11px;
  color: #666;
}
.floor-ad {
  padding: 0 12px;
  box-sizing: border-box;
  .ad-wrapper {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    .ad-image {
      width: 100%;
      display: block;
      object-fit: cover;
    }
  }
}
.goods-grid-old {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 12px;
  box-sizing: border-box;
}
.goods-card-old {
  width: 48.5%;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
  text-align: left;
  .goods-image-old {
    width: 100%;
    height: 150px;
    object-fit: cover;
  }
  .goods-info-old {
    padding: 6px;
  }
  .goods-name-old {
    font-size: 12px;
    color: #333;
    line-height: 1.4;
    height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .goods-price-old {
    font-size: 14px;
    color: #ee0a24;
    font-weight: 600;
    margin-top: 4px;
  }
}
.subscribe-section {
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  margin-bottom: 12px;
}
.subscribe-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
  text-align: left;
}
.subscribe-scroll-wrapper {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
.subscribe-list {
  display: flex;
}
.subscribe-item {
  width: 90px;
  margin-right: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  .sub-image {
    width: 90px;
    height: 60px;
    border-radius: 6px;
    object-fit: cover;
    margin-bottom: 4px;
  }
  .sub-name {
    font-size: 11px;
    color: #555;
    width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }
}
</style>
